import { Box, Stack } from "@mui/material";
import React from "react";
import { CustomBreadcrumbs } from "./CustomBreadcrumbs";
import { PageHeader } from "./PageHeader";

export const PageListLayout = (props) => {
  const {
    showHomeIcon = true,
    pageContent,
    breadcrumbs,
    headerText,
    rightContent,
    isChanged = false,
    tabs = null,
    children = null,
    sx = {},
  } = props;
  return (
    <Stack>
      <CustomBreadcrumbs
        breadcrumbs={breadcrumbs}
        showHomeIcon={showHomeIcon}
      />
      {(headerText || rightContent) && (
        <PageHeader
          headerText={headerText}
          rightContent={rightContent}
          isChanged={isChanged}
        />
      )}
      {tabs && (
        <Box
          className="sticky-Tab"
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            px: "8px",
            bgcolor: "#fff",
            top: "62px",
          }}
        >
          {tabs}
        </Box>
      )}

      {pageContent ? (
        pageContent
      ) : (
        <Stack p="8px" gap="8px" sx={sx}>
          {children}
        </Stack>
      )}
    </Stack>
  );
};
